import React from 'react';
import { UsersIcon, GraduationCapIcon, LayersIcon, ClockIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const PERFILES = [{
  icon: <GraduationCapIcon className="w-8 h-8 text-orange-500" data-id="element-139" />,
  text: 'Profes de secundaria (presencial o virtual)'
}, {
  icon: <UsersIcon className="w-8 h-8 text-orange-500" data-id="element-140" />,
  text: 'Profes particulares (clases 1:1 o grupos)'
}, {
  icon: <LayersIcon className="w-8 h-8 text-orange-500" data-id="element-141" />,
  text: 'Profes con cursos multinivel (A1–B2)'
}, {
  icon: <ClockIcon className="w-8 h-8 text-orange-500" data-id="element-142" />,
  text: 'Quienes quieren ahorrar tiempo (material listo, editable y ordenado)'
}];
export function IdealPara() {
  return <section className="py-8 bg-orange-50/70" data-id="element-143">
      <div className="max-w-5xl mx-auto px-4" data-id="element-144">
        <div className="text-center mb-6" data-id="element-145">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase" data-id="element-146">
            Ideal <span className="text-orange-500" data-id="element-147">para</span>
          </h2>
          <div className="w-24 h-2 bg-orange-400 mx-auto mt-4 rounded-full" data-id="element-148"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-149">
          {PERFILES.map((perfil, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white p-8 rounded-2xl text-center border-2 border-orange-100 hover:border-orange-300 transition-colors group shadow-sm" data-id="element-150">
              <div className="bg-orange-50 w-16 h-16 mx-auto rounded-full flex items-center justify-center shadow-md mb-6 group-hover:scale-110 group-hover:bg-orange-100 transition-all" data-id="element-151">
                {perfil.icon}
              </div>
              <p className="font-bold text-gray-800 text-lg leading-snug" data-id="element-152">
                {perfil.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}